module.exports = __webpack_public_path__ + "media/images/apps/google-play-lg-c3c1e4bf97156a0693dfb1c83eab2d7c.png";